/**
 * 数据验证工具
 */

/**
 * 验证手机号
 */
export function isValidPhone(phone: string): boolean {
  return /^1[3-9]\d{9}$/.test(phone)
}

/**
 * 验证邮箱
 */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

/**
 * 验证验证码（6位数字）
 */
export function isValidVerifyCode(code: string): boolean {
  return /^\d{6}$/.test(code)
}

/**
 * 验证 Token
 */
export function isValidToken(token: string): boolean {
  return typeof token === 'string' && token.length > 0
}

/**
 * 验证 URL
 */
export function isValidUrl(url: string): boolean {
  return /^(https?:)?\/\//i.test(url) || url.startsWith('/')
}

/**
 * 验证对象是否为空
 */
export function isEmpty(obj: any): boolean {
  if (obj === null || obj === undefined) return true
  if (typeof obj === 'string') return obj.trim().length === 0
  if (Array.isArray(obj)) return obj.length === 0
  if (typeof obj === 'object') return Object.keys(obj).length === 0
  return false
}

/**
 * 验证必填字段
 */
export function validateRequired(value: any, fieldName: string): void {
  if (isEmpty(value)) {
    throw new Error(`${fieldName} is required`)
  }
}

/**
 * 验证字段长度
 */
export function validateLength(value: string, min: number, max: number, fieldName: string): void {
  if (value.length < min || value.length > max) {
    throw new Error(`${fieldName} length must be between ${min} and ${max}`)
  }
}
